import pino from 'pino'

const REDACT_PATHS = [
  'req.headers.authorization',
  'req.headers.cookie',
  'res.headers.setCookie',
  'error.config.headers.cookie',
  'req.body',
  'res.body'
]

function resolveLoggerOptions(options = {}) {
  return {
    datadogAppId:
      options.datadogAppId ||
      process.env.NUXT_PUBLIC_DATADOG_APP_ID ||
      process.env.DATADOG_APP_ID ||
      'unknown',
    logLevel: options.logLevel || process.env.LOG_LEVEL || 'info'
  }
}

function createPinoLogger({ datadogAppId, logLevel }) {
  return pino({
    level: logLevel,
    messageKey: 'message',
    formatters: {
      level: label => ({ level: label.toUpperCase() })
    },
    timestamp: pino.stdTimeFunctions.isoTime,
    base: {
      ddsource: 'nuxt',
      app_id: datadogAppId
    },
    redact: {
      paths: REDACT_PATHS,
      censor: '***REDACTED***'
    }
  })
}

let loggerInstance = createPinoLogger(resolveLoggerOptions())

export function initLogger(options = {}) {
  loggerInstance = createPinoLogger(resolveLoggerOptions(options))
}

const logger = new Proxy({}, {
  get(_target, prop) {
    const value = loggerInstance[prop]
    return typeof value === 'function' ? value.bind(loggerInstance) : value
  }
})

export default logger
